import React, { useCallback, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Loader } from "../../common/loader";
import DialogBox from "../../common/DialogBox";
import { decryptPayload, getObjLength } from "../../helpers/utils";
import { PER_PAGE, ROLES } from "../../helpers/constants";
import { BrokerSignupPage } from "../BrokerSignupPage";
import { BrokerProperties } from "../BrokerProperties";
import CommonAgentsAdminTable from "./CommonAgentsAdminTable";
import ViewIconSVG from "../../common/customSVGs/ViewIconSVG";
import PlainAlertMessage from "../../common/PlainAlertMessage";
import { brokerAgentsAction } from "../../../redux/slices/brokers";
import { userProfileAction } from "../../../redux/slices/user/userProfileSlice";
import { agentsAdminAction } from "../../../redux/slices/brokers/agentAdminSlice";

const columns = [
  {
    key: 1,
    label: "",
    id: "action",
    minWidth: 10,
  },
  {
    key: 2,
    label: "Agent name",
    id: "full_name",
  },
  {
    key: 3,
    label: "Sales Representative",
    id: "rep_name",
    width: 50,
  },
  {
    key: 4,
    label: "Office",
    id: "office_name",
  },
  {
    key: 5,
    label: "Email",
    id: "email",
    width: 100,
  },

  {
    key: 6,
    label: "Total monitoring",
    id: "agent_properties_count",
    alignProp: "center",
    width: 50,
  },
  {
    key: 7,
    label: "Status",
    id: "agent_status",
    dropdown: true,
    bodypadding: "10px 13px",
    width: 200,
  },
];

const statusList = [
  {
    key: 1,
    label: "Active",
    id: "active",
    color: "#0CC04E",
  },
  {
    key: 2,
    label: "De-activated",
    id: "deactivated",
    color: "#FF006B",
  },
  {
    key: 3,
    label: "Released",
    id: "released",
    color: "#0D120B",
  },
  // {
  //   key: 4,
  //   label: "Something else",
  //   id: "something_else",
  //   color: "#FFAB17",
  // },
  {
    key: 5,
    label: "Pending",
    id: "pending",
    color: "#4C524A",
  },
];
const AgentsList = ({
  base_route = "broker",
  isSalesManager = false,
  isRepresentative = false,
  sm_tabData = {},
  isSuperAdmin = false,
  broker_data = {},
}) => {
  const dispatch = useDispatch();

  const [addAgentsModalOpen, setAddAgentsModalOpen] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [payload, setPayload] = useState({
    limit: 10,
    offset: 0,
  });
  const [viewProeprties, setViewProeprties] = useState(false);
  const [isEditAgentData, setIsEditAgentData] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState({});

  const manageSelectedProeprty = (data) => {
    setSelectedProperty(data);
    dispatch(brokerAgentsAction.fetchAgentProfileData({ data: data }));
  };

  const {
    agentAdminLoader,
    agentsDetails,
    agentProfileListData,
    isAddBtnClicked,
  } = useSelector((state) => state?.agentsAdmin);
  const { brokerDetails, agentCreateAccDetails, brokerAgentLoader } =
    useSelector((state) => state?.brokerAgents);
  const loggedInUserRole = decryptPayload(localStorage?.getItem("agent_role"));

  const handleViewPropertyBtn = (values) => {
    console.log(values);
    setSelectedProperty(values);
    setViewProeprties(true);
    if (isSuperAdmin) {
      dispatch(userProfileAction.setTabContentPadding(0));
    }
  };

  const backToAgentsList = () => {
    setSelectedProperty();
    setViewProeprties(false);
    dispatch(brokerAgentsAction.fetchAgentPropertyListData({}));
    dispatch(userProfileAction.setTabContentPadding(3));
    agentsListAPICall();
  };

  const addAgentProfile = (values, selectedAgentProfile = undefined) => {
    let formData = { ...values };
    delete formData?.password;
    delete formData?.new_password;
    delete formData?.old_password;

    if (
      isEditAgentData &&
      formData?.profile_img === selectedProperty?.agent_profile_img
    ) {
      delete formData.profile_img;
    }
    if (isEditAgentData && formData?.logo === selectedProperty?.logo) {
      delete formData.logo;
    }
    if (base_route !== "title") {
      delete formData.representative;
    }
    if (isRepresentative) {
      formData = {
        ...formData,
        representative: agentProfileListData?.data?.user_id,
      };
    }
    if (isSuperAdmin) {
      formData = {
        ...formData,
        from_super_admin: true,
        broker_id: broker_data?.id,
      };
    }
    let url = `broker/create-agent?source=${base_route}`;
    let sm_url = `sales-manager/create-agent?source=${base_route}`;
    let rep_url = `representative/create-agent?source=${base_route}`;
    if (isEditAgentData) {
      url = `broker/update-agent/${selectedProperty?.id}?source=${base_route}`;
      sm_url = `sales-manager/update-agent/${selectedProperty?.id}?source=${base_route}`;
      rep_url = `representative/update-agent/${selectedProperty?.id}?source=${base_route}`;
    }

    dispatch(
      brokerAgentsAction.createAgentAccount({
        url: isSalesManager ? sm_url : isRepresentative ? rep_url : url,
        data: {
          ...formData,
          source: base_route,
          agent_json: selectedAgentProfile,
          broker: brokerDetails?.data?.broker?.id,
          from_super_admin:
            loggedInUserRole === ROLES?.agentSubAdmin ? true : undefined,
        },
        brokertoken: !isSuperAdmin,
        token: isSuperAdmin,
      })
    );
  };
  const openAddAgentsModal = () => {
    setSelectedProperty();
    setIsEditAgentData(false);
    dispatch(brokerAgentsAction.fetchAgentProfileData({}));
    dispatch(agentsAdminAction.openUserSettingModal(false));
    setAddAgentsModalOpen(true);
  };
  const closeAddAgentsModal = () => {
    setAddAgentsModalOpen(false);
    setSelectedProperty();
    setIsEditAgentData(false);
    dispatch(brokerAgentsAction.fetchAgentProfileData({}));
    dispatch(brokerAgentsAction.fetchAgentCreateAccData({}));
    dispatch(brokerAgentsAction.clearAgentProfilePayload({}));
    dispatch(brokerAgentsAction.fetchAgentProfileListData({}));
    dispatch(agentsAdminAction.fetchUpdateAgentStatusData({}));
    dispatch(agentsAdminAction.openUserSettingModal(false));
    dispatch(agentsAdminAction.fetchIsAddBtnClicked(false));
  };

  const handleEditAgentModal = () => {
    setAddAgentsModalOpen(true);
    setIsEditAgentData(true);
    dispatch(agentsAdminAction.fetchCreateAgentOfficeData({}));
    dispatch(agentsAdminAction.openUserSettingModal(true));
  };

  const updateAgentStatus = (value, id, row) => {
    let data = {};
    let url = {};
    if (id === "rep_name") {
      data = { representative: value };
      url = `sales-manager/update-agent/${row?.id}?source=${base_route}`;
    }
    if (id === "agent_status") {
      url = `broker/update-status/${row?.id}?source=${base_route}`;
      data = { status: value };
    }
    if (id === "office_name") {
      url = `sales-manager/update-agent/${row?.id}?source=${base_route}`;
      data = { office_id: value };
    }
    if (isSuperAdmin) {
      data = { ...data, from_super_admin: true, broker_id: broker_data?.id };
    }
    dispatch(
      agentsAdminAction.updateAgentStatusData({
        url,
        data,
        brokertoken: !isSuperAdmin,
        token: isSuperAdmin,
      })
    );
  };

  const agentsListAPICall = useCallback(
    (offset = payload?.offset) => {
      let data = {
        limit: payload?.limit,
        offset: offset,
        // domain: broker,
      };
      if (isSuperAdmin || loggedInUserRole === ROLES?.agentSubAdmin) {
        data = {
          ...data,
          from_super_admin: true,
          broker_id: broker_data?.id || brokerDetails?.data?.broker?.id,
        };
      }
      let url = `broker/get-agents?source=${base_route}`;
      if (isSalesManager) {
        url = `sales-manager/get-agents?source=${base_route}`;
      }
      if (isRepresentative) {
        url = `representative/get-agents?source=${base_route}`;
      }
      dispatch(
        agentsAdminAction.getAgentsDetails({
          url,
          data,
          brokertoken: !isSuperAdmin,
          token: isSuperAdmin,
        })
      );
      window.scrollTo(0, 0);
    },
    [dispatch, payload?.limit, payload?.offset]
  );

  const agentOfficesListAPICall = () => {
    let data = {
      from_super_admin: true,
      broker_id: broker_data?.id,
    };

    dispatch(
      agentsAdminAction.getAgentOfficeDetails({
        url: `broker/get-offices?source=${base_route}`,
        data,
        token: true,
      })
    );
  };

  const salesRepresentativeListAPICall = () => {
    let data = {
      from_super_admin: true,
      broker_id: broker_data?.id,
    };

    dispatch(
      agentsAdminAction.getSalesRepresentativeDetails({
        url: `broker/representative/list?source=${base_route}`,
        data,
        token: true,
      })
    );
  };

  useEffect(() => {
    agentsListAPICall();
  }, [agentsListAPICall]);

  useEffect(() => {
    if (getObjLength(agentsDetails)) {
      if (agentsDetails?.success) {
        if (pageCount === 0)
          setPageCount(Math.ceil(agentsDetails?.count / PER_PAGE));

        if (agentsDetails?.count === 10) {
          setPayload((prevState) => ({
            ...prevState,
            offset: 0,
          }));
        }
      }
    }
  }, [agentsDetails]);

  useEffect(() => {
    if (isSuperAdmin) {
      columns.forEach((col) => {
        if (col.key === 1) {
          col.id = "sr";
          col.label = "No.";
        }
      });
      if (!columns.find((e) => e.key === 8)) {
        columns.push({
          key: 8,
          label: "Action",
          id: "action",
          minWidth: 10,
        });
      }
      if (!columns.find((e) => e.key === 9)) {
        columns.push({
          key: 9,
          id: "view",
          tooltipMsg: "View Properties",
          label: "",
          width: 100,
          content: <ViewIconSVG />,
        });
      }
      if (!columns.find((e) => e.key === 3) && base_route === "title") {
        columns.push({
          key: 3,
          label: "Sales Representative",
          id: "rep_name",
        });
      }

      columns.sort(function (a, b) {
        return a.key - b.key;
      });
      agentOfficesListAPICall(); //just for Super admin module
      salesRepresentativeListAPICall(); //just for Super admin module
    }
    if (base_route === "broker" || base_route === "attorney") {
      const index = columns.findIndex((obj) => obj.id === "rep_name");
      if (index !== -1) {
        columns.splice(index, 1); // Remove the object
      }
    }
    if (base_route === "attorney") {
      columns.forEach((col) => {
        if (col.key === 2) {
          col.label = "Attorney Name";
        }
      });
    }
  }, [isSuperAdmin]);

  useEffect(() => {
    if (isAddBtnClicked) {
      openAddAgentsModal();
    }
  }, [isAddBtnClicked]);

  return (
    <div>
      {viewProeprties ? (
        <div className="broker-create-account admin_wrapper">
          <BrokerProperties
            base_route={base_route}
            isREAgent={isRepresentative}
            isRepresentative={isRepresentative}
            rep_id={selectedProperty?.id}
            backToAgentsList={backToAgentsList}
            isSuperAdmin={isSuperAdmin}
          />
        </div>
      ) : (
        <CommonAgentsAdminTable
          columns={
            isSalesManager || isRepresentative
              ? sm_tabData?.sm_columns
              : columns
          }
          rowData={agentsDetails?.success ? agentsDetails?.data : []}
          btn_texts={
            isSalesManager
              ? sm_tabData?.sm_btn_texts
              : `Add ${base_route === "attorney" ? "Attorney" : "Agent"}`
          }
          addBtnClick={openAddAgentsModal}
          pageCount={pageCount}
          setPageCount={setPageCount}
          setPayload={setPayload}
          payload={payload}
          setEditRecord={handleEditAgentModal}
          setSelectedProperty={manageSelectedProeprty}
          handleViewIconBtn={handleViewPropertyBtn}
          selectedProperty={selectedProperty}
          isRepresentative={isRepresentative}
          viewPropertiesOption={isRepresentative}
          deleteAPIURL={
            isSalesManager
              ? "sales-manager/delete-agent"
              : isRepresentative
              ? "representative/delete-agent"
              : "broker/delete-agent"
          }
          customeDeleteMessage={`Are you sure you want to delete this ${
            base_route === "attorney" ? "Attorney" : "Agent"
          }? This action can not be undone.`}
          listAPICall={agentsListAPICall}
          statusList={statusList}
          updateAgentStatus={updateAgentStatus}
          base_route={base_route}
          isSuperAdmin={isSuperAdmin}
        />
      )}

      {addAgentsModalOpen && (
        <DialogBox
          dividers
          width={
            getObjLength(agentCreateAccDetails) &&
            agentCreateAccDetails?.success
              ? "sm"
              : "lg"
          }
          title={
            (!getObjLength(agentCreateAccDetails) ||
              !agentCreateAccDetails?.success) &&
            `${isEditAgentData ? "Edit" : "Add"} ${
              base_route === "attorney" ? "Attorney" : "Real Estate Agent"
            }`
          }
          contentClassName={"bg-white p-0"}
          openPopup={addAgentsModalOpen}
          setOpenPopup={setAddAgentsModalOpen}
          onClose={
            getObjLength(agentCreateAccDetails) &&
            agentCreateAccDetails?.success
              ? false
              : closeAddAgentsModal
          }
          content={
            !getObjLength(agentCreateAccDetails) ||
            !agentCreateAccDetails?.success ? (
              <BrokerSignupPage
                hide_top_footer_section={true}
                add_agent_profile={true}
                update_agent_profile={false}
                updateAgentProfile={addAgentProfile}
                closeAgentProfileModal={closeAddAgentsModal}
                base_route={base_route}
                isSalesManager={isSalesManager}
                isRepresentative={isRepresentative}
                isEdit={isEditAgentData}
                isSuperAdmin={isSuperAdmin}
              />
            ) : (
              <PlainAlertMessage
                type="Success"
                openPopup={true}
                onClose={true}
                onCloseFun={() => {
                  agentsListAPICall();
                  closeAddAgentsModal();
                }}
                message={agentCreateAccDetails?.message}
                footer={false}
              />
            )
          }
        />
      )}
      <Loader open={brokerAgentLoader} />
    </div>
  );
};

export default AgentsList;
